var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 25 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19 16.37l4.79 8.28c0.065 0.1121 0.1003 0.2389 0.1026 0.3684 0.0022 0.1295-0.0287 0.2574-0.0898 0.3717-0.0611 0.1142-0.1504 0.2109-0.2594 0.2809s-0.2341 0.111-0.3634 0.119l-3.31 0.21c-0.1165 0.0077-0.2295 0.0424-0.3302 0.1014s-0.1862 0.1407-0.2498 0.2386l-1.86 2.77c-0.0724 0.1071-0.1709 0.1938-0.2862 0.2522s-0.2436 0.0864-0.3727 0.0814-0.2548-0.0429-0.3653-0.11c-0.1104-0.0671-0.2019-0.1613-0.2658-0.2736l-3.64-6.3",
    fill: "#D3EBE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 16.37l4.79 8.28c0.065 0.1121 0.1003 0.2389 0.1026 0.3684 0.0022 0.1295-0.0287 0.2574-0.0898 0.3717-0.0611 0.1142-0.1504 0.2109-0.2594 0.2809s-0.2341 0.111-0.3634 0.119l-3.31 0.21c-0.1165 0.0077-0.2295 0.0424-0.3302 0.1014s-0.1862 0.1407-0.2498 0.2386l-1.86 2.77c-0.0724 0.1071-0.1709 0.1938-0.2862 0.2522s-0.2436 0.0864-0.3727 0.0814-0.2548-0.0429-0.3653-0.11c-0.1104-0.0671-0.2019-0.1613-0.2658-0.2736l-3.64-6.3",
    stroke: "#249D6B",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.12 20l-5.26 9.12c-0.06392 0.1123-0.15541 0.2065-0.26584 0.2736-0.11042 0.0671-0.23614 0.1049-0.36527 0.1099-0.12912 0.0051-0.25739-0.023-0.37268-0.0813-0.11529-0.0584-0.2138-0.1452-0.28621-0.2522l-1.86-2.77c-0.06356-0.0979-0.14908-0.1796-0.24977-0.2386-0.10069-0.0591-0.21377-0.0938-0.33023-0.1014l-3.32-0.22c-0.12929-0.0081-0.25437-0.049-0.36337-0.119s-0.19829-0.1667-0.25941-0.281c-0.06111-0.1142-0.09202-0.2421-0.08978-0.3716 0.00223-0.1296 0.03754-0.2564 0.10256-0.3684l4.41-7.7",
    fill: "#D3EBE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.12 20l-5.26 9.12c-0.06392 0.1123-0.15541 0.2065-0.26584 0.2736-0.11042 0.0671-0.23614 0.1049-0.36527 0.1099-0.12912 0.0051-0.25739-0.023-0.37268-0.0813-0.11529-0.0584-0.2138-0.1452-0.28621-0.2522l-1.86-2.77c-0.06356-0.0979-0.14908-0.1796-0.24977-0.2386-0.10069-0.0591-0.21377-0.0938-0.33023-0.1014l-3.32-0.22c-0.12929-0.0081-0.25437-0.049-0.36337-0.119s-0.19829-0.1667-0.25941-0.281c-0.06111-0.1142-0.09202-0.2421-0.08978-0.3716 0.00223-0.1296 0.03754-0.2564 0.10256-0.3684l4.41-7.7",
    stroke: "#249D6B",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 20.09c5.1197 0 9.27-4.1503 9.27-9.27 0-5.1197-4.1503-9.27-9.27-9.27s-9.27 4.1503-9.27 9.27c0 5.1197 4.1503 9.27 9.27 9.27z",
    fill: "#D3EBE1",
    stroke: "#249D6B",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 20.09c5.1197 0 9.27-4.1503 9.27-9.27 0-5.1197-4.1503-9.27-9.27-9.27s-9.27 4.1503-9.27 9.27c0 5.1197 4.1503 9.27 9.27 9.27z",
    fill: "#D3EBE1",
    stroke: "#249D6B",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.73 10.76l2.56 2.55 4.98-4.98",
    stroke: "#249D6B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(.1001 .5498)",
    width: 24.8,
    height: 29.9,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/Ribbon.27a2e9b4bcea6c6df186e4feb81d68dc.svg";
export { ForwardRef as ReactComponent };